import React from 'react';
import Box from '@material-ui/core/Box';

interface LoaderProps {
  height?: string;
  size?: string;
  margin?: string;
}

export function Loader(props:LoaderProps) {

  let height = props.height || '100vh';
  let size = props.size || '100px'
  let margin = props.margin || '0';

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      p={1}
      m={1}
      css={{ height: height, padding: '0', margin: margin }}
    >
      <div className="loaderContainer" style={{height : size, width : size}}>
      <div className="loaderSpec loaderred"></div>
      </div>
    </Box>
  );
}
